import { apiClient } from '../shared/services/api';

export interface Notification {
  id: string;
  type: 'STORY_APPROVED' | 'STORY_REJECTED' | 'STORY_REVISION_REQUESTED' | 'FRIEND_MESSAGE' | 'FRIEND_REQUEST' | 'STORY_COMMENT' | 'STORY_RATING' | 'SYSTEM_ANNOUNCEMENT';
  title: string;
  message: string;
  link?: string;
  isRead: boolean;
  createdAt: string;
  readAt?: string;
}

export interface NotificationPage {
  content: Notification[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  size: number;
}

export const notificationService = {
  /**
   * Get paginated notifications
   */
  async getNotifications(page = 0, size = 20): Promise<NotificationPage> {
    const response = await apiClient.get(`/notifications?page=${page}&size=${size}`);
    return response.data;
  },

  /**
   * Get unread notifications
   */
  async getUnreadNotifications(): Promise<Notification[]> {
    const response = await apiClient.get('/notifications/unread');
    return response.data;
  },

  /**
   * Get unread notification count
   */
  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get('/notifications/unread/count');
    return response.data.count;
  },

  /**
   * Mark a notification as read
   */
  async markAsRead(notificationId: string): Promise<void> {
    await apiClient.post(`/notifications/${notificationId}/read`);
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<void> {
    await apiClient.post('/notifications/read-all');
  },

  /**
   * Delete a notification
   */
  async deleteNotification(notificationId: string): Promise<void> {
    await apiClient.delete(`/notifications/${notificationId}`);
  }
};
